// Beglin Orthodontics (Dr. Frank Beglin) - four online-bookable offices across two
// states and TWO Edge catalogs (like Las Vegas). Carson catalog fd23dbaf (Carson
// City + Yerington, NV); Bishop catalog 97236a3b (Bishop + Mammoth Lakes, CA).
// (Dayton NV is not online-bookable.) Backend: bondLocations.ts BEGLIN_CARSON_CITY /
// _YERINGTON / _BISHOP / _MAMMOTH (brandId "beglin"); backendBrandKey() routes the
// Bishop-catalog offices to the "beglin_bishop" backend key. All leads share brandId
// "beglin" (one LeadSigma). Native booking via ortho2-newpatient backend (WCF intake
// disabled). English-only.
import type { BrandConfig } from "./types";

export const beglin: BrandConfig = {
  slug: "beglin",
  brandId: "beglin",
  brandName: "Beglin Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/5525e581-ecc4-4023-994d-1ffcbe5e8acd.png",
  phone: "(775) 882-5911",
  phoneHref: "tel:+17758825911",
  theme: { primary: "#C3002F", primaryDark: "#8A0021" }, // scoured 2026-07-20 beglinsmiles.com (red)
  locales: ["en"],
  // Beglin charges for adult consultations - the only Bond brand that does.
  consultIsFree: false,
  locations: {
    BEGLIN_CARSON_CITY: {
      id: "BEGLIN_CARSON_CITY",
      name: "Carson City",
      addressLines: ["525 W Washington St", "Carson City, NV 89703"],
      mapsUrl: "https://maps.google.com/?q=525+W+Washington+St+Carson+City+NV+89703",
      timezone: "America/Los_Angeles",
    },
    BEGLIN_YERINGTON: {
      id: "BEGLIN_YERINGTON",
      name: "Yerington",
      addressLines: ["20 NV-208", "Yerington, NV 89447"],
      mapsUrl: "https://maps.google.com/?q=20+NV-208+Yerington+NV+89447",
      timezone: "America/Los_Angeles",
    },
    BEGLIN_BISHOP: {
      id: "BEGLIN_BISHOP",
      name: "Bishop",
      addressLines: ["350 W Line St, #B", "Bishop, CA 93514"],
      mapsUrl: "https://maps.google.com/?q=350+W+Line+St+B+Bishop+CA+93514",
      timezone: "America/Los_Angeles",
    },
    BEGLIN_MAMMOTH: {
      id: "BEGLIN_MAMMOTH",
      name: "Mammoth Lakes",
      addressLines: ["664 Old Mammoth Rd", "Mammoth Lakes, CA 93546"],
      mapsUrl: "https://maps.google.com/?q=664+Old+Mammoth+Rd+Mammoth+Lakes+CA+93546",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: {
    CARSON_CITY: "BEGLIN_CARSON_CITY",
    YERINGTON: "BEGLIN_YERINGTON",
    BISHOP: "BEGLIN_BISHOP",
    MAMMOTH: "BEGLIN_MAMMOTH",
    MAMMOTH_LAKES: "BEGLIN_MAMMOTH",
  },
};
